import { useQuery } from "@tanstack/react-query";
import adminApiClient, { AddCollectionQrStats } from "../../api/admin";

const useAddCollectionQrStats = (days: number, enabled: boolean) => {
  return useQuery<AddCollectionQrStats>({
    queryKey: ["addCollectionQrStats", days],
    queryFn: () => adminApiClient.getAddCollectionQrStats(days),
    enabled,
  });
};

export default useAddCollectionQrStats;
